// extracted by mini-css-extract-plugin
module.exports = {"icon-container":"icon-container_icon-container__PMF3H"};